import SplitPaneMode from "./components/split-pane-mode"
export default function SplitPaneModePlugin() {
  return {
    // statePlugins: {
    //   layout: {
    //     actions,
    //     selectors,
    //   }
    // },

    components: {
      SplitPaneMode
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/plugins/split-pane-mode/index.js